module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"holder":"Account owner","settings":"Settings","changePass":"Change password"}}')
  delete Component.options._Ctor
}
